































import Vue from "vue";
import SelectList from "@/components/shared/SelectList.vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import {
  JinroPlayerDocument,
  JinroGameDocument,
  VoteDocument,
  JinroRoomDocument
} from "../../../services/datatypes";
import SelectResult from "@/components/shared/SelectResult.vue";
import { db, firestore } from "@/scripts/firebase";
import { collectionName } from "@/services/collection-name";
import { DialogProgrammatic as Dialog } from "buefy";
import OwnerNotificationDialogue from "./OwnerNotificationDialogue.vue";

@Component({
  components: {
    SelectResult,
    SelectList,
    OwnerNotificationDialogue
  }
})
export default class Vote extends Vue {
  @Prop() readonly jinroGameId!: string;
  @Prop() readonly jinroPlayinfoId!: string;

  get isPublicViewing(): boolean {
    // public view path example:  /j/TAYBteCF9uJnFVyUtP8W/public
    const elmnts = this.$route.path.split("/");

    return elmnts.length > 3 && this.$route.path.split("/")[3] === "public";
  }
  get skeltonRowNumber(): number {
    return this.survivors.length;
  }

  get submittedPlayerName(): string {
    if (!this.votes) {
      return "";
    }
    const playerId = this.$route.params.jinroPlayerId;
    const submittedPlayer = this.votes.find(vote => {
      return vote.fromPlayer.id === playerId;
    });
    if (!submittedPlayer) {
      return "";
    }
    return submittedPlayer.toPlayer.playerName;
  }

  get jinroGame(): JinroGameDocument | null {
    if (this.$store.state.jinroGame) {
      return this.$store.state.jinroGame;
    }
    return null;
  }
  get survivors(): Array<JinroPlayerDocument> {
    if (this.jinroGame) {
      return this.jinroGame.survivors;
    }
    return [];
  }

  get votes(): Array<VoteDocument> {
    if (!this.$store.state.jinroGamePlayinfo) {
      return [];
    }
    if (!this.$store.state.jinroGamePlayinfo.votes) {
      return [];
    }
    return this.$store.state.jinroGamePlayinfo.votes;
  }

  get hasSubmited(): boolean {
    const me = this.votes.find(vote => {
      return vote.fromPlayer.id === this.$route.params.jinroPlayerId;
    });
    return me ? true : false;
  }

  async handleCancelSubmit() {
    const votes = this.votes;
    const afterVotes = votes.filter(vote => {
      return vote.fromPlayer.id !== this.$route.params.jinroPlayerId;
    });

    await this.refUpdatedTo.set(
      {
        votes: afterVotes,
        timeUpdated: firestore.FieldValue.serverTimestamp()
      },
      {
        merge: true
      }
    );

    return;
  }

  async handleSubmit(selectedOption: string) {
    const players: Array<JinroPlayerDocument> = this.survivors;
    const fromPlayer = players.find(player => {
      return player.id === this.$route.params.jinroPlayerId;
    });
    const toPlayer = players.find(player => {
      return player.id === selectedOption;
    });

    const vote = {
      fromPlayer: fromPlayer,
      toPlayer: toPlayer
    };

    try {
      // update vote info to jinroplayinfo
      await this.refUpdatedTo.set(
        {
          votes: firestore.FieldValue.arrayUnion(vote),
          timeUpdated: firestore.FieldValue.serverTimestamp()
        },
        {
          merge: true
        }
      );
    } catch (err) {
      console.error(err);
    }
  }

  get refUpdatedTo(): firebase.firestore.DocumentReference {
    return db
      .collection(collectionName.jinrogames)
      .doc(this.jinroGameId)
      .collection(collectionName.jinroplayinfo)
      .doc(this.jinroPlayinfoId);
  }

  get selectLabel(): string {
    return "人狼だと思うプレイヤーを選択してください。";
  }

  get votablePlayers(): Array<JinroPlayerDocument> {
    if (!this.$store.state.jinroGamePlayinfo) {
      return [];
    }
    if (!this.$store.state.jinroGamePlayinfo.votablePlayers) {
      return [];
    }
    return this.$store.state.jinroGamePlayinfo.votablePlayers;
  }
}
